import { CTAButton, CTALink, Heading3, P } from '@ovotech/nebula';
import { AnalyticsClick, AnalyticsRender } from '@ovotech/ui-tools';
import React from 'react';
import { RenewalBannerWarning } from './RenewalBannerWarning';
import { StyledLink, SecondaryButton } from './styled';
import { Banner } from '@/src/components/ActionCentre/Banners/Banner';
import { ACTION_CENTRE } from '@/src/constants/analytics-subjects';
import { ROUTE_RENEWAL } from '@/src/constants/routes';

function VariableContractEarlyRenewal({
  id,
  utmSource,
  dismiss,
  onClick,
}: {
  id: string;
  utmSource?: string;
  dismiss?: (daysToExpiration?: number) => void;
  onClick: () => void;
}) {
  return (
    <AnalyticsRender name={ACTION_CENTRE} properties={{ id }}>
      <Banner icon="shield" data-testid="renewal-notification-variable-early">
        <Heading3 as="h2">Protect yourself from price rises</Heading3>
        <P data-testid="new-variable-contract">
          You’re on our variable plan, so your rates could go up or down. Fancy
          something more worry-free? Our fixed rate energy plans lock your
          prices until your contract ends, offering you peace of mind in a
          changing market.
        </P>
        <RenewalBannerWarning />
        <AnalyticsClick name={ACTION_CENTRE} properties={{ id }}>
          <CTALink
            as={StyledLink}
            data-testid="renew-button"
            to={`${ROUTE_RENEWAL}?utm_source=${utmSource}`}
            variant="missionPrimary"
            onClick={onClick}
          >
            View fixed-rate plans
          </CTALink>
        </AnalyticsClick>
        <CTAButton
          as={SecondaryButton}
          variant="missionSecondary"
          onClick={() => {
            dismiss?.(14);
          }}
        >
          Remind me later
        </CTAButton>
      </Banner>
    </AnalyticsRender>
  );
}

export default VariableContractEarlyRenewal;
